import {api} from 'services/api';
import {ObjectId} from 'types/object-id';
import {ProductVariant} from 'types/product-variant';
import {ResponseData} from 'types/response-data';
import queryParams from 'utils/query-params';

const getProductExports = api.injectEndpoints({
  endpoints: builder => ({
    getProductExports: builder.query<Response, Request>({
      query: params => {
        return {
          method: 'GET',
          url: `export/product-variants`,
          params: queryParams(params, '|'),
        };
      },
    }),
  }),
});

type Request = {};

type Response = ResponseData<ProductVariant[]>;

export const {useLazyGetProductExportsQuery} = getProductExports;
